export default "__VITE_ASSET__C_PCiEJ5__"